import React from 'react';

const passwordErrors = errors =>
   errors.map(row => {
      switch (row) {
         case 'password.too.short':
            return 'The password is too short min 8 characters';
         case 'password.insufficient.characteristics':
            return (
               <div>
                  The password does not match all the required characteristics:
                  <br />
                  <ul>
                     <li>At least 1 digit</li>
                     <li>At least 1 non-alphanumeric character</li>
                     <li>At least 1 alphabetical character</li>
                     <li>Numerical sequences are prohibited</li>
                     <li>Alphabetical sequences are prohibited</li>
                     <li>Qwerty sequences are prohibited</li>
                     <li>4 repeat characters are prohibited</li>
                  </ul>
               </div>
            );
         case 'password.too.long':
            return 'The password is too long max 128 characters';
         case 'password.illegal.sequence':
            return 'The password contains an illegal sequence of characters';
         case 'password.invalid':
            return 'The password is invalid';
         default:
            return '';
      }
   });

export default passwordErrors;